import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ButtonHLPure } from "../../pures";
import {
  SignatureRequestProfileListSignersPure,
  SignatureRequestProfileListSignersAuthorizerPure,
} from "../../pures";
import { Grid } from "@material-ui/core";
import "./signature-request-profile-resume.css";
import moment from "moment";
import "moment/locale/es";
import LabelPure from "../../pures/label/label.pure";
import { NIL as NIL_UUID } from 'uuid';

const SignatureRequestProfileResumeView = (props) => {
  const { t } = useTranslation();

  const { step, onHandleBack, onHandleNext, onSubmitSign, signatureProfileSelected, companyIdSelected, categoryIdSelected, subCategoryIdSelected, typeDocumentSelected, companies, categories, subCategories, proofLifeCheckboxId, proofOfLifeChecked, language } = props;
  const { next, back } = step;
  const [currentSystem, setCurrentSystem] = useState("");
  const [date, setDate] = useState("");
  const [nameFile, setNameFile] = useState('')
  const [companySelected, setCompanySelected] = useState('')
  const [categorySelected, setCategorySelected] = useState('')
  const [subCategorySelected, setSubcategorySelected] = useState('')
  const [typeDocumentWasSelected, setTypeDocumentWasSelected] = useState('')
  const [labelProofOfLife, setLabelProofOfLife] = useState(t("signatureRequestProfileResume.prooOfLife.nothing"))

  let infodevice = currentSystem.toLowerCase();
  let isMobile = infodevice.includes("android");
  isMobile = isMobile || infodevice.includes("iphone");
  isMobile = isMobile || infodevice.includes("ipad");
  isMobile = isMobile || infodevice.includes("mobile");


  useEffect(() => {
    setCurrentSystem(navigator.userAgent);
  }, []);

  function isTouchScreendevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
  }

  if (isTouchScreendevice()) {
    isMobile = true;
  }

  useEffect(() => {
    if(proofOfLifeChecked){
      let signersHaveProofOfLife = props.signers.map((signer) => {
        let signerHasProofOfLife = (signer.proofOfLife) ? true : false
        return signerHasProofOfLife
      })

      let labelProofOfLife = (signersHaveProofOfLife.includes(true)) ? t("signatureRequestProfileResume.prooOfLife.required")  : t("signatureRequestProfileResume.prooOfLife.signers.no.selected") 
      setLabelProofOfLife(labelProofOfLife)
    }
  },[])

  useEffect(() => {
    if (!signatureProfileSelected || !props.selectedFileName) return
    let name = props.selectedFileName
    if (signatureProfileSelected && signatureProfileSelected.documentProfile && signatureProfileSelected.documentProfile.documentProfile && signatureProfileSelected.documentProfile.documentProfile.length > 0) {
      let names = []
      signatureProfileSelected.documentProfile.documentProfile.map((profile) => {
        if (profile && profile.document && profile.document.file && profile.document.file.name) {
          names.push(profile.document.file.name)
        }
      })

      let allNames = (names.length > 0) ? names.join(', ') : ''
      name = allNames
    }

    setNameFile(name)
  }, [signatureProfileSelected, props.selectedFileName])

  useEffect(() => {
    moment.locale(language || "es");
    let dateNew = moment(props.date).format("DD/MMM/YYYY");
    dateNew = (dateNew) ? dateNew.toLocaleLowerCase() : new Date()
    dateNew = (dateNew) ? dateNew.replace('.', "") : new Date()
    setDate(dateNew);
  }, [props.date]);

  useEffect(() => {
    if (companyIdSelected) {
      let company = companies.find(company => company.id === companyIdSelected)
      let companyName = (company && company.id && company.id !== NIL_UUID) ? company.companyName : ''
      setCompanySelected(companyName)
    }

    if (categoryIdSelected) {
      let category = categories.find(category => category.id === categoryIdSelected)
      let categoryName = (category && category.name) ? category.name : ''
      setCategorySelected(categoryName)
    }

    if (subCategoryIdSelected) {
      let subcategory
      let subCategoryName = ''
      let sub = subCategories.find(subCat => subCat.subcategory.id === subCategoryIdSelected)
      if (!sub) {
        subCategories.map((subCat) => {
          let subItemFind = subCat.items.find(subItem => subItem.subcategory.id === subCategoryIdSelected)
          if (subItemFind) subcategory = subItemFind
        })
      } else {
        subcategory = sub
      }

      subCategoryName = (subcategory && subcategory.subcategory && subcategory.subcategory.name) ? subcategory.subcategory.name : ''
      setSubcategorySelected(subCategoryName)
    }

    if (typeDocumentSelected) {
      let typeDocument = (typeDocumentSelected && typeDocumentSelected.name) ? typeDocumentSelected.name : ''
      setTypeDocumentWasSelected(typeDocument)
    }

  }, [companyIdSelected, categoryIdSelected, subCategoryIdSelected, typeDocumentSelected])

  let isSignatureTypeSelected =
    props.signatureTypeAutographChecked === true
      ? props.signatureTypeAutographChecked
      : false || props.signatureTypeESignChecked === true
        ? props.signatureTypeESignChecked
        : false || props.signatureTypeAdvancedChecked === true
          ? props.signatureTypeAdvancedChecked
          : false;

  return (
    <div className="container-signature-profile-resume">
      <Grid
        container
        lg={12}
        md={12}
        sm={12}
        xs={12}
        className="container-resume"
      >
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <div className="container-info-data">
            {/* <div className="text-direction-resume">
              <LabelPure title={t("signatureRequestProfileView.signatureName")} />
              <p className="subtitle-resume">{props.nameSignature}</p>
            </div> */}
            <div className="text-direction-resume">
              <LabelPure title={t("signatureRequestProfileResume.signatureName")} />
              <p className="text-info-resume-description">{props.nameSignature}</p>
            </div>
            {/* <div className="text-direction-resume">
              <LabelPure title={t("signatureRequestProfileResume.resume")} />
              <p className="text-info-resume-description">
                {props.description}
              </p>
            </div> */}
            <div className="text-direction-resume">
              <LabelPure title={t("signatureRequestProfileResume.instructions")} />
              <p className="text-info-resume-description">{props.comments}</p>
            </div>
          </div>
          <hr className="line-section" />
          <div className="container-info-signers">
            <div className="text-direction-resume">
              <LabelPure title={t("signatureRequestProfileResume.documentName")} />
              <p className="text-info-resume-description">
                {nameFile}
              </p>
            </div>
            <div className="text-direction-resume">
              <LabelPure title={t("signatureRequestProfileResume.limitDate")} />
              <p className="text-info-resume-description">{date}</p>
            </div>
            <div className="text-direction-resume text-direction-process">
              <LabelPure title={t("signatureRequestProfileResume.servicePSC")} />

              {props.serviceCMChecked === true &&
                props.serviceSTChecked === false ? (
                <p className="text-info-resume-description">
                  {t("signatureRequestProfileResume.psc.message")}
                </p>
              ) : (
                ""
              )}
              {props.serviceCMChecked === false &&
                props.serviceSTChecked === true ? (
                <p className="text-info-resume-description">
                  {t("signatureRequestProfileResume.psc.timestamp")}
                </p>
              ) : (
                ""
              )}
              {props.serviceCMChecked === true &&
                props.serviceSTChecked === true ? (
                <p className="text-info-resume-description">
                  {t("signatureRequestProfileResume.psc.both")}
                </p>
              ) : (
                ""
              )}
              {props.serviceCMChecked === false &&
                props.serviceSTChecked === false ? (
                <p className="text-info-resume-description">{t("signatureRequestProfileResume.no.psc")}</p>
              ) : (
                ""
              )}
            </div>
            <div className="text-direction-resume">
              <LabelPure title={t("signatureRequestProfileResume.signatureType")} />
              {props.signatureTypeId === 2 ? (
                <p className="text-info-resume-description">
                  {t("signatureRequestProfileResume.advanced")}
                </p>
              ) : (
                ""
              )}
              {props.signatureTypeId === 3 ? (
                <p className="text-info-resume-description">
                 {t("signatureRequestProfileResume.autograph")}
                </p>
              ) : (
                " "
              )}
              {props.signatureTypeId === 1 ? (
                <p className="text-info-resume-description">{t("signatureRequestProfileResume.eSign")}</p>
              ) : (
                ""
              )}
            </div>
            <div className="text-direction-resume">
              <LabelPure title={`${t("signatureProfilesView.biometric.validation")}:`} />
                <p className="text-info-resume-description">
                  {labelProofOfLife}
                </p>
            </div>
            <div className="text-direction-resume">
              <LabelPure title={t("signatureRequestProfileResume.signatureFlow")} />
              {props.processTypeId === 2 ? (
                <p className="text-info-resume-description">{t("signatureRequestProfileResume.sequential")}</p>
              ) : (
                ""
              )}
              {props.processTypeId === 3 ? (
                <p className="text-info-resume-description">{t("signatureRequestProfileResume.aprovation")}</p>
              ) : (
                " "
              )}
              {props.processTypeId === 1 ? (
                <p className="text-info-resume-description">{t("signatureRequestProfileResume.random")}</p>
              ) : (
                ""
              )}
              {props.processTypeId === 4 ? (
                <p className="text-info-resume-description">
                  {t("signatureRequestProfileResume.aprovationSequencial")}
                </p>
              ) : (
                ""
              )}
            </div>
          </div>
          <hr className="line-section" />
          <div className="container-info-vault">
            <div className="text-direction-resume">
              <LabelPure title={t("signatureRequestProfileResume.companyName")} />
              <p className="text-info-resume-description">
                {companySelected}
              </p>
            </div>
            <div className="text-direction-resume">
              <LabelPure title={t("signatureRequestProfileResume.categoryName")} />
              <p className="text-info-resume-description">
                {categorySelected}
              </p>
            </div>
            <div className="text-direction-resume">
              <LabelPure title={t("signatureRequestProfileResume.subcategoryName")} />
              <p className="text-info-resume-description">
                {subCategorySelected}
              </p>
            </div>
            <div className="text-direction-resume">
              <LabelPure title={t("signatureRequestProfileResume.typeDocumentName")} />
              <p className="text-info-resume-description">
                {typeDocumentWasSelected}
              </p>
            </div>
          </div>
          <hr className="line-section" />
        </Grid>
      </Grid>

      {props.processTypeAprovationChecked === true ||
        props.processTypeAprovationSequentialChecked === true ? (
        <Grid lg={12} md={12} sm={12} xs={12}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <p className="form-detail-labels">
              {t("signatureRequestView2.validator")}
            </p>
            <SignatureRequestProfileListSignersAuthorizerPure
              {...props}
              // validateInput={props.validateInput}
              // setSigners={props.setSigners}
              isSignatureTypeSelected={isSignatureTypeSelected}
              signers={props.signers}
              type={"validators"}
              toggleDialogDeleteSigner={props.toggleDialogDeleteSigner}
              DragCell={props.DragCell}
            />
          </Grid>
          <div className="signatureRequestProfileResumeView-signers-autorizators">
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <LabelPure title={t("configurationSignatureHistoryDetailView.signersGrid")} />

              <SignatureRequestProfileListSignersPure
                {...props}
                validateInput={props.validateInput}
                // setSigners={props.setSigners}
                isSignatureTypeSelected={isSignatureTypeSelected}
                isAtgrafSignature={props.isAtgrafSignature}
                // signers={props.signers}
                toggleDialogDeleteSigner={props.toggleDialogDeleteSigner}
                signatureTypeAdvancedChecked={props.signatureTypeAdvancedChecked}
                signatureTypeESignChecked={props.signatureTypeESignChecked}
                signatureTypeAutographChecked={
                  props.signatureTypeAutographChecked
                }
              />
            </Grid>
          </div>
        </Grid>
      ) : (
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <LabelPure title={t("configurationSignatureHistoryDetailView.signersGrid")} />

          <SignatureRequestProfileListSignersPure
            {...props}
            validateInput={props.validateInput}
            setSigners={props.setSigners}
            isSignatureTypeSelected={isSignatureTypeSelected}
            isAtgrafSignature={props.isAtgrafSignature}
            signers={props.signers}
            toggleDialogDeleteSigner={props.toggleDialogDeleteSigner}
            showOnlyNumber={true}
          />
        </Grid>
      )}

      <div className="action-buttons">
        <ButtonHLPure
          nameBtn={back}
          onClickBtn={onHandleBack}
        />
        <ButtonHLPure
          nameBtn={next}
          primary
          onClickBtn={(e) => onSubmitSign(e)}
        />
      </div>
    </div>
  );
};

export { SignatureRequestProfileResumeView as default };
